import md5 from "md5";
import Cookies from 'js-cookie';

// 定义生成表单哈希所需的参数接口
interface FormHashParams {
  username: string;  // 用户名
  uid: string | number;  // 用户ID
  saltkey?: string;  // 安全密钥
}

/**
 * 生成表单哈希值
 * @param username - 用户名
 * @param uid - 用户ID
 * @param saltkey - 安全密钥
 * @returns 8位长度的MD5哈希值
 */
export function formhash({ username, uid, saltkey = ''}: FormHashParams): string {
  const specialadd = ''; // 据说区分项目用的，默认为空
  const salt = saltkey || Cookies.get('H5VF_2132_saltkey');
  const timestamp = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
  const authkey = process.env.AUTHKEY;  // 从环境变量获取认证密钥
  const authkey_md5 = md5(`${authkey}${salt}`);  // 生成认证密钥的MD5值

  const hashadd = "";  // 额外的哈希字符串，目前为空
  
  // 计算 MD5 哈希
  const hashInput = `${timestamp.toString().slice(0, -7)}${username}${uid}${authkey_md5}${hashadd}${specialadd}`;
  const md5Hash = md5(hashInput); // 使用 md5 函数计算哈希

  // 返回哈希的子串
  return md5Hash.substring(8, 16);
}
